import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import type {
    FavoriteData,
    FavoriteOperationError,
    OutlookFavoriteKind,
} from 'owa-favorites-types';

export interface AddFavoriteCompletedActionMessage {
    temporaryData: FavoriteData;
    favoriteData: FavoriteData;
    newIndex: number | undefined;
}
export const addFavoriteCompleted: (
    temporaryData: FavoriteData,
    favoriteData: FavoriteData,
    newIndex?: number
) => AddFavoriteCompletedActionMessage = action(
    'addFavoriteCompleted',
    (
        temporaryData: FavoriteData,
        favoriteData: FavoriteData,
        newIndex?: number
    ): AddFavoriteCompletedActionMessage =>
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!
         *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        addDatapointConfig(
            'AddFavoriteCompleted',
            undefined,
            {
                customData: {
                    temporaryFavoriteId: temporaryData.favoriteId,
                    favoriteId: favoriteData.favoriteId,
                    favoriteKind: favoriteData.type,
                },
            },
            {
                temporaryData,
                favoriteData,
                newIndex,
            }
        )
);

export interface AddFavoriteFailedActionMessage {
    error: FavoriteOperationError;
    favoriteData: FavoriteData;
    favoriteKind: OutlookFavoriteKind;
}
export const addFavoriteFailed: (
    error: FavoriteOperationError,
    favoriteData: FavoriteData
) => AddFavoriteFailedActionMessage = action(
    'addFavoriteFailed',
    (error: FavoriteOperationError, favoriteData: FavoriteData): AddFavoriteFailedActionMessage =>
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!
         *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        addDatapointConfig(
            'AddFavoriteFailed',
            undefined,
            {
                customData: {
                    errorMessage: error ? error.message : 'Undefined error',
                    cV: error ? error.correlationVector : 'Undefined error',
                    favoriteId: favoriteData.favoriteId,
                    favoriteKind: favoriteData.type,
                },
            },
            {
                error,
                favoriteData,
                favoriteKind: favoriteData.type,
            }
        )
);

export interface AddFavoriteToStoreActionMessage {
    favoriteData: FavoriteData;
    newIndex: number | undefined;
}
export const addFavoriteToStore: (
    favoriteData: FavoriteData,
    newIndex?: number
) => AddFavoriteToStoreActionMessage = action(
    'addFavoriteToStore',
    (favoriteData: FavoriteData, newIndex?: number): AddFavoriteToStoreActionMessage =>
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!
         *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        addDatapointConfig(
            'AddFavoriteToStore',
            undefined,
            {
                customData: {
                    favoriteId: favoriteData.favoriteId,
                    favoriteKind: favoriteData.type,
                },
            },
            {
                favoriteData,
                newIndex,
            }
        )
);
